import { render, staticRenderFns } from "./TerminToolbarComp.vue?vue&type=template&id=0df04e66&scoped=true&"
import script from "./TerminToolbarComp.vue?vue&type=script&lang=ts&"
export * from "./TerminToolbarComp.vue?vue&type=script&lang=ts&"
import style0 from "./TerminToolbarComp.vue?vue&type=style&index=0&id=0df04e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df04e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VMenu,VSwitch,VTooltip})
